import request from '@/service/request'

export default class siteService {
  /**
   * 驿站模糊搜索
   * @param data
   * @returns
   */
  static dimStation(data: Record<string, any>): Promise<any> {
    return request.post('/station/dimStation', data)
  }
}
